document.addEventListener("DOMContentLoaded", function () {
  const swiperContainers = document.querySelectorAll(".mySwiper");

  swiperContainers.forEach(function (container) {
    const nextButton = container.querySelector(".swiper-button-next");
    const prevButton = container.querySelector(".swiper-button-prev");
    const pagination = container.querySelector(".swiper-pagination");

    new Swiper(container, {
      slidesPerView: "auto",
      spaceBetween: 10,
      pagination: {
        el: pagination,
        clickable: true,
      },
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
    });
  });
});

// homepage landing slider section code written as the slider button are not showing bydefault
window.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(
    ".landing_page_slider .swiper-button"
  );

  buttons.forEach((button) => {
    button.classList.remove("swiper-button-disabled", "swiper-button-lock");
    button.removeAttribute("disabled");
  });
});
